import React from 'react';
import fisioImage from '../../src/assets/fisio.jpg';


const FisioHero = ({ setCurrentPage }) => {
  const specialties = [
    {
      title: "Fisioterapia Deportiva",
      description: "Recuperación y optimización para atletas.",
      icon: (
        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
        </svg>
      )
    },
    {
      title: "Prevención de Lesiones",
      description: "Evita problemas antes de que aparezcan.",
      icon: (
        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
        </svg>
      )
    },
    {
      title: "Fisioterapia Respiratoria",
      description: "Mejora tu capacidad pulmonar y respiración.",
      icon: (
        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"></path>
        </svg>
      )
    },
    {
      title: "Fisioterapia Geriátrica",
      description: "Mantenemos la independencia en adultos mayores.",
      icon: (
        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.747 0-3.332.477-4.5 1.253"></path>
        </svg>
      )
    }
  ];

  return (
    <section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-24 md:py-32 mt-16">
     
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-4 drop-shadow-lg">
          El movimiento es vida
        </h1>
        <p className="text-lg md:text-xl mb-10 max-w-3xl mx-auto opacity-90">
          Recupera tu Movimiento, Vive sin Dolor. Fisioterapia de vanguardia para una vida plena y activa. Tu bienestar es nuestra prioridad.
        </p>
        <button
          onClick={() => setCurrentPage('contact')}
          className="bg-white text-blue-700 px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-blue-100 transition-all duration-300 transform hover:scale-105"
        >
          Agenda tu Cita Hoy
        </button>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {specialties.map((spec, index) => (
            <div key={index} className="bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm p-6 rounded-xl shadow-lg flex flex-col items-center text-white">
              {spec.icon}
              <h3 className="text-xl font-semibold mt-3 mb-1">{spec.title}</h3>
              <p className="text-sm opacity-80">{spec.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FisioHero;